export default {"src":"/oferta/_next/static/media/food.b319704f.svg","height":41,"width":30,"blurWidth":0,"blurHeight":0};